import { XStack } from '@/components/ui/layout/layout';

import { AccountBadge } from './account-badge';

import type { WikiAccount } from '../people-wiki.types';

/** The accounts as badges. */
export const AccountsCell = ({ accounts }: { accounts: WikiAccount[] }) =>
  accounts.length === 0 ? (
    <span className="text-foreground-subtle">—</span>
  ) : (
    <XStack wrap className="gap-1.5">
      {accounts.map((account) => (
        <AccountBadge key={account.id} account={account} />
      ))}
    </XStack>
  );
